<template>
  <div class="arrow_box">
    <div
        class="remote_note_arrow"
        :class="noteArrowProps ? '' : 'hidden'"
        @click="clickNoteArrowBtn(false)"
    >
      <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="none" viewBox="0 0 12 12">
        <path fill="#3d4857" d="M5 10.243L3.586 8.828 6.414 6 3.586 3.172 5 1.757 9.243 6 5 10.243z"/>
      </svg>
    </div>
    <div
        class="remote_note_arrow"
        :class="noteArrowProps ? 'hidden' : ''"
        @click="clickNoteArrowBtn(true)"
    >
      <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="none" viewBox="0 0 12 12"
           style="transform: rotate(180deg);">
        <path fill="#3d4857" d="M5 10.243L3.586 8.828 6.414 6 3.586 3.172 5 1.757 9.243 6 5 10.243z"/>
      </svg>
    </div>
  </div>
</template>
<script>
export default {
  name : 'noteArrow',
  props : ['noteArrowProps'],
  methods: {
    clickNoteArrowBtn(boolean) {
      this.$emit('clickNoteArrowBtn', boolean);
    }
  }
}
</script>